import {
  FETCH_AGENCIES,
  CREATE_AGENCY,
  UPDATE_AGENCY
} from './mutations-types'
import firebase from '../../../firebase/main'
import helpers from '../../../helpers/functions'

export default {
  fetchAgencies ({ commit }, payload) {
    return new Promise(resolve => {
      resolve(firebase.Agencies.fetchAgencies())
    })
      .then(res => {
        commit(FETCH_AGENCIES, res)
        return true
      })
      .catch(err => helpers.handleError(err))
  },
  createAgency ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      resolve(firebase.Agencies.createAgency(payload))
    })
      .then(res => {
        const agency = {
          id: res.id,
          data: payload
        }
        commit(CREATE_AGENCY, agency)
        return res.id
      })
      .catch(err => helpers.handleError(err))
  },
  updateAgency ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      resolve(firebase.Agencies.updateAgency(payload))
    })
      .then(res => {
        commit(UPDATE_AGENCY, payload)
        return true
      })
      .catch(err => helpers.handleError(err))
  }
}
